import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { ApplicationState, AppState } from "../store";
import { ROLE_ADMIN } from "../models/Constants";

// -------------
// Props
type PurePrivateRouteProps = { returnElement: React.ReactNode };
export type PrivateRouteProps = AppState & PurePrivateRouteProps;
export const PrivateRoute = (props: PrivateRouteProps) => {
    //HANDLE USER
    //IS FIX CODE
    const isAuthorize = props.user // (props.user && props.user.cognit_user.challengeName !== 'NEW_PASSWORD_REQUIRED') ? true : false;
    // const isNewPasswordRequired = props.user && props.user.cognit_user.challengeName === 'NEW_PASSWORD_REQUIRED';
    if (isAuthorize) {
        let prevLocation = sessionStorage.getItem("prevLocation");
        if (prevLocation && (prevLocation.startsWith("/setting") || prevLocation.startsWith("/users"))) {
            if (props.user?.userRole === ROLE_ADMIN){
                return <>{props.returnElement}</>;
            } else {
                sessionStorage.removeItem("prevLocation");
                return <Navigate to={"/"} replace={true}/>
            }
        }
        return <>{props.returnElement}</>
    }
    // else if (isNewPasswordRequired) {
    //     return <Navigate to={"/changepass"} replace={true} />
    // }
    return (
        <Navigate to={"/login"} replace={true} />
    );
    
};

export default connect((state: ApplicationState) => state.app)(PrivateRoute);